import { render, staticRenderFns } from "./managment-section.vue?vue&type=template&id=5e7f25b6&scoped=true"
import script from "./managment-section.vue?vue&type=script&lang=ts"
export * from "./managment-section.vue?vue&type=script&lang=ts"
import style0 from "./managment-section.vue?vue&type=style&index=0&id=5e7f25b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7f25b6",
  null
  
)

export default component.exports